export const faqs = [
  {
    question: '¿Cómo recibiré la Ruta Hipotiroidismo™?',
    answer:
      'Una vez confirmado tu pago recibirás acceso inmediato al área de descarga, donde podrás obtener todos los tomos y bonos en formato digital. Podrás acceder desde computadora, tablet o celular, las veces que quieras.',
  },
  {
    question: '¿La Ruta sirve para médicos de cualquier país?',
    answer:
      'Sí. La Ruta Hipotiroidismo™ está basada en principios clínicos y recomendaciones respaldadas por evidencia científica ampliamente utilizada en la práctica médica. Es útil para médicos generales, residentes, internistas, endocrinólogos y otros profesionales de habla hispana.',
  },
  {
    question: '¿Necesito ser endocrinólogo para aprovechar el contenido?',
    answer:
      'No. La Ruta fue diseñada para que cualquier médico que atienda pacientes con hipotiroidismo pueda seguir un proceso claro de diagnóstico, tratamiento y seguimiento, incluso si no se dedica exclusivamente a la endocrinología.',
  },
  {
    question: '¿Los archivos son descargables?',
    answer:
      'Sí. Todo el material se entrega en formato PDF de alta calidad para que puedas descargarlo y consultarlo cuando lo necesites, incluso sin conexión a internet.',
  },
  {
    question: '¿Es un pago único?',
    answer:
      'Sí. Realizas un único pago y obtienes acceso de por vida a todo el contenido incluido en la oferta, sin membresías ni cobros recurrentes.',
  },
  {
    question: '¿En cuánto tiempo puedo terminar la Ruta?',
    answer:
      'Depende de tu ritmo. Muchos médicos comienzan a utilizar los algoritmos y protocolos desde el mismo día de la compra, mientras que el contenido completo puede estudiarse progresivamente y quedar como material permanente de consulta para la práctica clínica.',
  },
  {
    question: '¿Qué pasa si la Ruta no cumple mis expectativas?',
    answer:
      'Estás completamente protegido por nuestra garantía de 7 días. Si durante ese período consideras que el contenido no era lo que esperabas, solo debes escribirnos y te devolveremos el 100% de tu dinero. Sin explicaciones complicadas.',
  },
  {
    question: '¿Seguiré necesitando revisar las guías clínicas?',
    answer:
      'La Ruta Hipotiroidismo™ no sustituye el juicio clínico ni las guías oficiales. Su objetivo es organizar y simplificar la información basada en evidencia para ayudarte a tomar decisiones con mayor rapidez y seguridad durante la consulta, evitando tener que buscar constantemente entre múltiples documentos.',
  },
]
